<template src="./EmojiRating.html" />

<script lang="js">

import Vue from "vue";

export default Vue.extend({
  name: "nmouc-emojirating",
  mounted() {
    this.rating = 0
    this.refreshEmojis()
  },
  props: {
    rating: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      emoji1: `${this.$publicPath}emojis/bad-white.svg`,
      emoji2: `${this.$publicPath}emojis/ok-white.svg`,
      emoji3: `${this.$publicPath}emojis/good-white.svg`,
    }
  },
  watch:{
    rating(){
      this.refreshEmojis()
    }
  },
  methods: {
    rateBad() {
      this.rating = 1
      this.refreshEmojis()
    },
    rateOK() {
      this.rating = 2
      this.refreshEmojis()
    },
    rateGood() {
      this.rating = 3
      this.refreshEmojis()
    },
    refreshEmojis() {
      this.$emit('rating', this.rating)
      switch (this.rating) {
        case 1:
          this.emoji1 = `${this.$publicPath}emojis/bad-white-active.svg`
          this.emoji2 = `${this.$publicPath}emojis/ok-white.svg`
          this.emoji3 = `${this.$publicPath}emojis/good-white.svg`
          break
        case 2:
          this.emoji1 = `${this.$publicPath}emojis/bad-white.svg`
          this.emoji2 = `${this.$publicPath}emojis/ok-white-active.svg`
          this.emoji3 = `${this.$publicPath}emojis/good-white.svg`
          break
        case 3:
          this.emoji1 = `${this.$publicPath}emojis/bad-white.svg`
          this.emoji2 = `${this.$publicPath}emojis/ok-white.svg`
          this.emoji3 = `${this.$publicPath}emojis/good-white-active.svg`
          break
        default:
          this.emoji1 = `${this.$publicPath}emojis/bad-white.svg`
          this.emoji2 = `${this.$publicPath}emojis/ok-white.svg`
          this.emoji3 = `${this.$publicPath}emojis/good-white.svg`
      }
    }
  }
});
</script>

<style lang="scss">
.container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
}
.leftEmoji {
  width: auto;
}
.centerEmoji {
  width: auto;
}
.rightEmoji {
  width: auto;
}
.emojiBtn {
  background-color: transparent;
  border: none;
}
</style>
